import { useSyncExternalStore } from "react";
import { userStore } from "../model/userStore";

export const useUserStore = () => {
  return useSyncExternalStore(
    userStore.subscribe,
    userStore.getState,
    userStore.getState,
  );
};
